import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { appClient } from "config/axios";
import PATHS from "config/paths";
import { QueryKeys } from "config/query-keys";

export const archiveNotification = (id: string | undefined): Promise<{}> => {
  return appClient.httpClient.delete(`${PATHS.notificationService.baseURL}/archive/${id}`);
};

export const useArchiveNotification = () => {
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: async (data, __, ___) => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.NOTIFICATIONS] });
      notification.success({
        message: "Archived",
        description: "Notification has been successfully archived.",
        duration: 2,
      });
    },

    mutationFn: archiveNotification,
  });
};
